import api from '../../api/modules/students-solved-quizzes';
import { Module } from 'vuex';

const initialState = {};

const studentQuizModule: Module<any, any> = {
  namespaced: true,
  state: initialState,
  actions: {
    async getQuiz(_, { studioURL, quizId }): Promise<SimpleQuizResponse> {
      const quiz = await api.getQuiz(studioURL, quizId);
      return quiz;
    },
    async viewQuiz(_, { studioURL, quizId }): Promise<void> {
      await api.viewQuiz(studioURL, quizId);
    },
    async getSolvedQuizzes(
      _,
      { studioURL }
    ): Promise<StudentSolvedQuizResponse> {
      const solvedQuizzes = await api.getSolvedQuizzes(studioURL);
      return solvedQuizzes;
    },
    async getSolvedQuiz(
      _,
      { studioURL, solvedQuizId }
    ): Promise<StudentSolvedQuizResponse> {
      const solvedQuiz = await api.getSolvedQuiz(studioURL, solvedQuizId);
      return solvedQuiz;
    },
    async startQuiz(
      _,
      { studioURL, quizId }
    ): Promise<StudentSolvedQuizResponse> {
      const solvedQuiz = await api.startQuiz(studioURL, quizId);
      return solvedQuiz;
    },
    async retakeQuiz(_, { studioURL, quizId }): Promise<void> {
      return await api.retakeQuiz(studioURL, quizId);
    },
    async finishQuiz(_, { studioURL, solvedQuizId }): Promise<void> {
      return await api.finishQuiz(studioURL, solvedQuizId);
    },
    async answerQuizQuestion(
      _,
      { studioURL, solvedQuizId, data }
    ): Promise<void> {
      return await api.answerQuizQuestion(studioURL, solvedQuizId, data);
    },
    async addSolvedQuizAnswerFile(
      _,
      { studioURL, solvedQuizId, solvedQuizAnswerId, fileId }
    ): Promise<void> {
      return await api.addSolvedQuizAnswerFile(
        studioURL,
        solvedQuizId,
        solvedQuizAnswerId,
        fileId
      );
    },
  },
};

export default studentQuizModule;
